export default "__VITE_ASSET__DRgXiSXR__"